//@ts-nocheck
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Modal,
  FormControlLabel,
  Checkbox,
  Paper,
  Stepper,
  Step,
  StepLabel,
  Tabs,
  Tab,
  Box,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import ModeCommentIcon from "@mui/icons-material/ModeComment";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import PersonAddAltSharpIcon from "@mui/icons-material/PersonAddAltSharp";
import DashboardLayout from "lib/LayoutContainers/DashboardLayout";
import withDommer from "pages/withDommer";
import { useSubmissionStore } from "../../models/applications/SubmissionStore";
import { useStoreActions, useStoreState } from "easy-peasy";
import { post, get } from "requests";
import Submission from "pages/applications/tabs/submissions";
import BankStatementTab from "pages/applications/tabs/bankStatements/BankStatementTab";
import Files from "pages/applications/tabs/files";
import Grid from "@mui/material/Grid";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import {
  SCRUBBER,
  SUBMISSION,
  UPDATE,
  APPLICATION_STATUS,
  ROLE_NAME,
  JUNIOR_UNDERWRITER,
  SENIOR_UNDERWRITER,
} from "constants/Constants";
import { rolePermissionExists } from "utils/CommonUtils";
import FullPageLoader from "components/Loader/FullPage";
import { DraftsTwoTone, Refresh, Groups, Route, ArrowBack, PieChart, InsertChart, PieChartOutline, PieChartTwoTone } from "@mui/icons-material";
import MDSnackbar from "components/MDSnackbar";
import BackgroundChecks from "./tabs/backgroundChecks/BackGroundChecks";
import UsersRole from "./tabs/submissions/UsersRole";
import NotesContent from "./tabs/Notes/NotesContent";
import SendStatusEmailModal from "./components/SendStatusEmailModal";
import ConfirmDialog from "components/SweetAlert";
import UserAvatar from "./tabs/submissions/UserAvatar";
import { en_message, MESSAGES } from "constants/Messages";
import UnderWriting from "./tabs/underwriting";
import StorageUtils from "utils/StorageUtils";
import EmailTabComponent from "./tabs/Email";
import MeetingPage from "./tabs/Meetings";
import DecisionLogicTab from "./tabs/decisionLogic";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { formatCurrencyUSD } from "utils/CommonUtils";
import WarningDialog from "components/WarningDialog";
import { ADMIN, READ } from "requests/constants";
import AnalysisTools from "./tabs/analysisTools";

export const groupUsersByInitials = (users: AssignedUser[]) => {
  const grouped: { [key: string]: AssignedUser[] } = {};

  users.forEach((user) => {
    if (user.firstName && user.lastName) {
      const initials = `${user.firstName[0]}${user.lastName[0]}`.toUpperCase();
      if (!grouped[initials]) {
        grouped[initials] = [];
      }
      grouped[initials].push(user);
    }
  });
  return grouped;
};
const Detail = () => {
  const { userList } = useSubmissionStore();
  const { id } = useParams();
  const location = useLocation();

  const [isFromDeals, setIsFromDeals] = useState(false);
  const [isFromOffers, setIsFromOffers] = useState(false);

  const [alert, setAlert] = useState<{
    type: "success" | "error" | "warning" | null;
    message: string;
  } | null>(null);
  const [preApprovedLocal, setPreApprovrdLocal] = useState(false);
  const [showUndoAlert, setShowUndoAlert] = useState(false);
  const [isUndoConfirmed, setIsUndoConfirmed] = useState(false);
  const [isRefi, setIsRefi] = useState(false);
  const [assignedUsers, setAssignedUsers] = useState<
    Array<{ fullName: string; firstName: string; lastName: string; role: string; color: string }>
  >([]);
  const navigate = useNavigate();
  const [focusedAccount, setFocusedAccount] = useState<{
    accountnumber: string;
    monthyear: string;
  } | null>(null);

  const integMode = localStorage.getItem("achIntegrationMode");
  const isBuiltInMode = integMode && integMode.toLowerCase() === "built-in_mode";

  const roles = {
    admin: "1",
    user: "2",
    syndicator: "3",
    operator: "4",
    "all data readonly": "5",
    "syndicator(limited)": "6",
    rep: "7",
    underwriter: "8",
    scrubber: "9",
    submission: "10",
    "ISO Representative": "11",
    "Senior Underwriter": "12",
    "Junior Underwriter": "13",
    "underwriter(limited)": "14",
  };

  const {
    steps,
    merchantData,
    merchantBusinessInfo,
    merchantAndOwners,
    dealApplicationData,
    fetchInitialData,
    reInitializeSubmissionStore,
    storeData,
    saveMerchantData,
    submissionLoader,
    fetchMerchantData,
  } = useSubmissionStore();

  const theme = useTheme();

  const [refresh, setRefresh] = useState(false);
  const _steps = steps.map((st) => st.name);
  const [activeTab, setActiveTab] = React.useState("submission");
  const [isSendEmail, setIsSendEmail] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [declineApp, setDeclineApp] = useState(false);
  const [requiredInfo, setRequiredInfo] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const isMobile = useMediaQuery(theme.breakpoints.down("xxl"));
  const commissionAmount = useStoreState(
    (state: any) => state.heldBackCommissionStore.commissionAmount
  );
  const totalCommission = useStoreState(
    (state: any) => state.heldBackCommissionStore.totalCommission
  );
  const fetchComissions = useStoreActions(
    (actions: any) => actions.heldBackCommissionStore.fetchCommissions
  );
  const resetOffers = useStoreActions((actions: any) => actions.offerStore.resetStore);
  const resetHeldbacks = useStoreActions(
    (actions: any) => actions.heldBackCommissionStore.resetStore
  );
  const resetSyndication = useStoreActions((actions: any) => actions.syndicationStore.resetStore);
  const selectedRows = useStoreState((state: any) => state.offerStore.selectedRows);
  const fetchOffers = useStoreActions((actions: any) => actions.offerStore.fetchOffers);
  const externalFunders = useStoreState(
    (state: any) => state.heldBackCommissionStore.externalFunders
  );
  const heldbacksData = useStoreState((state: any) => state.heldBackCommissionStore.heldbacks);
  const deleteHeldBack = useStoreActions(
    (actions: any) => actions.heldBackCommissionStore.deleteCommission
  );
  const saveHeldback = useStoreActions(
    (actions: any) => actions.heldBackCommissionStore.saveHeldback
  );
  const getExternalFunders = useStoreActions(
    (actions: any) => actions.heldBackCommissionStore.getExternalFunders
  );

  const fetchRecalculatedApplication = useStoreActions(
    (actions: any) => actions.offerStore.fetchRecalculatedApplication
  );
  const handleBankAmountUpdate = useStoreActions(
    (actions: any) => actions.heldBackCommissionStore.handleForTotalBankFeeOrInvestorEditChanges
  );
  const updateSyndicatorsPercentage = useStoreActions(
    (actions: any) => actions.syndicationStore.updateSyndicatorsPercentage
  );

  const refreshHeldabckComm = useStoreActions(
    (actions: any) => actions.heldBackCommissionStore.refresh
  );
  const refreshSynd = useStoreActions((actions: any) => actions.syndicationStore.fetchSyndicators);
  const saveFinalOffer = useStoreActions((actions: any) => actions.offerStore.saveContractTerms);
  const handleSaveOfferAction = useStoreActions(
    (actions: any) => actions.offerStore.handleSaveOffer
  );

  const [emailTemplateName, setEmailTemplateName] = useState(null);

  const getRandomColor = (name: string): string => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash % 360);

    const saturation = 80;
    const lightness = 40;

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  };
  const preApprovedSteps = ["DRAFT", "APPROVED"];

  const [validationError, setValidationError] = useState<any[]>(null);
  const tabs = [
    "submission",
    "files",
    "back_statements",
    "underwriting",
    "notes",
    "background_checks",
  ];

  const [permittedTabs, setPermittedTabs] = useState({});

  const {
    timestamp,
    activeStep,
    subStatus,
    isPreApproved,
    isLastStep,
    isDeclined,
    dealId,
    hasActiveSchedules,
    refinancedDealNumbers,
  } = useStoreState((state) => state.dealApplication);

  const {
    fetchTimestamp,
    setIsPreApproved,
    setIsLastStep,
    setIsDeclined,
    updateStatusAndSubStatus,
    updateDealApplicationNo,
    fetchDealIdByApplicationId,
    reInitializeDealApplicationStore,
    checkIfActiveSchedules,
    setHasActiveSchedules,
    updateEndDateForActiveSchedulesForRefinancedDeals,
    validateRequiredStepInfo,
  } = useStoreActions((actions) => actions.dealApplication);

  const offerDetails = useStoreState((state: any) => state.offerStore.contractTerms);
  const getContractTerms = useStoreActions((actions: any) => actions.offerStore.getContractTerms);
  const saveContractTerms = useStoreActions((actions: any) => actions.offerStore.saveContractTerms);
  const hasFetchedContractTermsRef = React.useRef(false);
  const [jrUnderwriterVisibleSteps, setJrUnderwriterVisibleSteps] = useState([]);
  const [srUnderwriterVisibleSteps, setSrUnderwriterVisibleSteps] = useState([]);
  const [hasDealApplicationAccess, setHasDealApplicationAccess] = useState(true);

  const fetchThreshold = async () => {
    try {
      const response = await get("/steps/thresholds");
      const threshold = response?.jrUnderWriterStepNames;
      const srThresholds = response?.srUnderWriterStepNames;

      if (threshold) {
        setJrUnderwriterVisibleSteps(threshold);
      } else {
        setJrUnderwriterVisibleSteps([]);
      }

      if (srThresholds) {
        setSrUnderwriterVisibleSteps(srThresholds);
      } else {
        setSrUnderwriterVisibleSteps([]);
      }
    } catch (error) {
      console.error("Error fetching  Underwriter thresholds:", error);
      setJrUnderwriterVisibleSteps([]);
      setSrUnderwriterVisibleSteps([]);
    }
  };

  const checkHasPermission = (stepName: string, role: string): boolean => {
    try {
      if (!stepName) return true;
      if (
        role?.toLowerCase() === JUNIOR_UNDERWRITER &&
        jrUnderwriterVisibleSteps.length > 0 &&
        !jrUnderwriterVisibleSteps.includes(stepName)
      ) {
        return false;
      } else if (
        role?.toLowerCase() === SENIOR_UNDERWRITER &&
        srUnderwriterVisibleSteps.length > 0 &&
        !srUnderwriterVisibleSteps.includes(stepName)
      ) {
        return false;
      }
      return true;
    } catch (error) {
      console.error("Permission check failed:", error);
      return true;
    }
  };

  useEffect(() => {
    async function reInitializeStores() {
      reInitializeSubmissionStore();
      await reInitializeDealApplicationStore();
    }

    async function fetchAllSubmissioninfo(appId: any) {
      await reInitializeStores();
      fetchInitialData(appId);
      await fetchTimestamp(appId);
      await getContractTerms(appId);
      await getExternalFunders();
      await refreshHeldabckComm(appId);
      await fetchThreshold();
    }

    try {
      setIsLoading(true);
      if (id) {
        fetchAllSubmissioninfo(id);
      } else {
        console.warn("No ID available yet");
      }
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    try {
      const queryParams = new URLSearchParams(location.search);
      const source = queryParams.get("source");
      setIsFromDeals(source === "deals");
      setIsFromOffers(source === "offers");
    } catch (error) {
      console.error("Failed to parse query params:", error);
      setIsFromDeals(false);
    }
  }, [location.search]);

  useEffect(() => {
    try {
      setIsLoading(true);
      setIsPreApproved(dealApplicationData?.subStatus === APPLICATION_STATUS.DRAFT);
      setIsLastStep(timestamp?.length + 1 === steps?.length);
      setIsDeclined(dealApplicationData?.subStatus === "Declined");
      setIsRefi(dealApplicationData?.dealSubstatus === "Refinanced");
      if (dealApplicationData?.subStatus === APPLICATION_STATUS.APPROVED) {
        fetchDealIdByApplicationId({ dealApplicationId: id });
      }
      setStepInfo();
    } finally {
      setIsLoading(false);
    }
  }, [timestamp, steps, dealApplicationData]);

  useEffect(() => {
    try {
      setIsLoading(true);
      const step = steps[activeStep];
      const currRole = localStorage.getItem("roleName");
      if (step && currRole) {
        const stepName = step?.name;
        setHasDealApplicationAccess(checkHasPermission(stepName, currRole));
      }
      setRequiredInfo(step?.requiredInfo);
      setPermittedTabs(
        (step &&
          step?.roles &&
          roles[currRole] &&
          step.roles[roles[currRole] - 1] &&
          step.roles[roles[currRole] - 1].tabs) ||
          {}
      );
      const selectedTab = step?.selectedTab;

      if (tabs.includes(selectedTab)) {
        setActiveTab(selectedTab);
      } else if (selectedTab === "offerDetails") {
        setActiveTab("underwriting");
      } else {
        setActiveTab("submission");
      }
    } finally {
      setIsLoading(false);
    }
  }, [steps, activeStep, jrUnderwriterVisibleSteps, srUnderwriterVisibleSteps]);

  useEffect(() => {
    const updateDefaultFunder = async () => {
      try {
        if (activeStep < 1 && !hasFetchedContractTermsRef.current) {
          hasFetchedContractTermsRef.current = true;

          const contractTerms = await getContractTerms(id);

          if (!contractTerms?.contractTerms?.funder) {
            const updatedTerms = {
              ...contractTerms,
              applicationId: id,
            };

            await saveContractTerms(updatedTerms);
            await getContractTerms(id);
          }
        }
      } catch (error) {
        console.error("Failed to update default funder:", error);
      }
    };
    updateDefaultFunder();
  }, [activeStep, id]);

  const fetchUsersRole = async () => {
    try {
      const applicationId = id;
      const usersRoleResponse = await get(`getUsersRole/${applicationId}`);
      const updatedAssignedUsers: AssignedUser[] = [];

      Object.entries(usersRoleResponse).forEach(([role, userNames]) => {
        (userNames as string[]).forEach((fullName) => {
          const [firstName, ...lastNameArr] = fullName.split(" ");
          const lastName = lastNameArr.join(" ");
          const user = userList?.find((u) => u.fullName === fullName);

          if (user) {
            updatedAssignedUsers.push({
              fullName,
              firstName,
              lastName,
              role,
              color: getRandomColor(firstName),
              userId: user.id,
            });
          }
        });
      });
      setAssignedUsers(updatedAssignedUsers);
    } catch (error) {
      console.error("Error fetching usersRole:", error);
    }
  };

  const autoAssignRoles = async () => {
    try {
      const applicationId = id;
      const userId = localStorage.getItem("logInUserId");
      const roleName = localStorage.getItem("roleName");

      if (applicationId && userId && roleName) {
        const request: any = {
          applicationId: applicationId,
          currentUserId: userId,
          roleName: roleName,
        };

        await post("autoAssignRoles", request);
        fetchUsersRole();
      }
    } catch (error) {
      console.error("Error auto assigning Jr underwr:", error);
    }
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    if (newValue === "underwriting") {
      if (!offerDetails?.contractTerms?.funder) {
        setValidationError(["Funder"]);
        return;
      }
    }

    setActiveTab(newValue);
    if (newValue !== "bank_statements") {
      setFocusedAccount(null);
    }
  };

  const handleViewBankStatement = (accountData: { accountnumber: string; monthyear: string }) => {
    setFocusedAccount(accountData);
    setActiveTab("bank_statements");
  };

  const handleBack = async () => {
    try {
      setRefresh(true);
      await post("dealApplication/goBackToPreviousSubStatus", {
        dealApplicationId: id,
      });
      await fetchTimestamp(id);
      fetchInitialData(id);
    } finally {
      setRefresh(false);
    }
  };

  const handleUpdateStatus = async (
    emailPayload: any,
    recipients: any,
    isSkip = false,
    decline = false
  ) => {
    try {
      setRefresh(true);
      let status = "";
      let subStatus = "";

      if (decline) {
        status = "Closed";
        subStatus = "Declined";
      } else if (isPreApproved) {
        status = "Closed";
        subStatus = "Pre-Approved";
        setPreApprovrdLocal(true);
      } else {
        status = "Pending";
        subStatus = dealApplicationData?.subStatus;
      }

      await updateStatusAndSubStatus({
        dealApplicationId: Number(id),
        status,
        subStatus,
        recipients,
        isPreApproved: isPreApproved || preApprovedLocal,
        emailDetails: emailPayload,
        isSkip,
        offersToSend:
          emailTemplateName && emailTemplateName === "event.deal.dealApplication.status.multiOffers"
            ? selectedRows
            : [],
      });

      await fetchTimestamp(id);
      fetchInitialData(id);
      await fetchOffers(id);
    } catch (error) {
      console.error("Failed to update status:", error);
    } finally {
      setRefresh(false);
    }
  };

  const updateDealApplication = async () => {
    const partyId = merchantAndOwners.merchantId;
    if (partyId) {
      const requestBody = {};
      requestBody["partyId"] = partyId;
      const userId = Number(localStorage.getItem("logInUserId"));
      requestBody["tenantId"] = Number(localStorage.getItem("tenantId"));
      requestBody["userId"] = userId;
      requestBody["applicationId"] = id;
      await post("updateDealApplication", requestBody);
    }
  };

  const handleResetStatus = async () => {
    await updateStatusAndSubStatus({
      dealApplicationId: Number(id),
      status: "Pending",
      subStatus: "Reset",
    });
    await fetchTimestamp(id);
    fetchInitialData(id);
  };

  const handleUndoDeal = async () => {
    try {
      setRefresh(true);
      await get(`deal/deleteDeal/${dealId}`);
      await updateStatusAndSubStatus(dealId, "Pending", "undo");
      await updateStatusAndSubStatus({
        dealApplicationId: Number(id),
        status: "Pending",
        subStatus: "undo",
      });
      await fetchTimestamp(id);
      fetchInitialData(id);
      setAlert({ type: "success", message: "Undo Deal Successful" });
    } finally {
      setRefresh(false);
    }
  };

  const handleStatusUpdateClick = async () => {
    if (activeStep !== null && activeStep !== undefined && activeStep < 2) {
      await autoAssignRoles();
    }

    await populateSingleOffer();
    if (isLastStep) {
      const validationResult = await validateRequiredStepInfo({
        merchantInfo: merchantAndOwners,
        requiredInfo: [
          "businessLegalName",
          "contractTerms.funder",
          "fundedAmount",
          "paybackFactor",
          "purchaseAmount",
        ],
        offerDetails: offerDetails,
      });

      if (!validationResult?.valid) {
        setValidationError(validationResult?.error);
        return;
      }
      await fetchComissions(id);

      const isActiveSchedulePresent = await checkIfActiveSchedules({
        dealApplicationId: Number(id),
      });
      if (isActiveSchedulePresent) {
        return;
      }
    }
    await updateDealApplication();
    try {
      if (parseInt(subStatus) >= parseInt(steps.length) - 2) {
        await updateDealApplicationNo({ dealApplicationId: Number(id) });
        await fetchInitialData(id);
      }
    } catch {
      console.error("Failed to update Application Number.");
    }
    validateAllActions();
  };

  const handlePreApprovedClick = async () => {
    const validationResult = await validateRequiredStepInfo({
      merchantInfo: merchantAndOwners,
      requiredInfo: [
        "businessLegalName",
        "contractTerms.funder",
        "fundedAmount",
        "paybackFactor",
        "purchaseAmount",
      ],
      offerDetails: offerDetails,
    });

    if (!validationResult?.valid) {
      setValidationError(validationResult?.error);
      return;
    }

    await fetchComissions(id);
    const isActiveSchedulePresent = await checkIfActiveSchedules({ dealApplicationId: Number(id) });
    if (isActiveSchedulePresent) {
      return;
    }
    setShowEmailModal(true);
  };

  const validateAllActions = async () => {
    const validationResult = await validateRequiredStepInfo({
      merchantInfo: merchantAndOwners,
      requiredInfo: requiredInfo,
      offerDetails: offerDetails,
    });

    if (!validationResult?.valid) {
      setValidationError(validationResult?.error);
      return;
    }

    if (isSendEmail) {
      setShowEmailModal(true);
    } else {
      handleUpdateStatus(null, null, true, false);
    }
  };

  const populateSingleOffer = async () => {
    try {
      const step = steps[activeStep];
      const acceptOffer = step?.acceptSingleOffer ?? false;

      if (acceptOffer) {
        const offers = await get(`getMultipleOffers/${id}`);

        if (
          Array.isArray(offers) &&
          offers.length === 1 &&
          !["ACCEPTED", "DECLINED"].includes(offers[0]?.status?.toUpperCase?.())
        ) {
          const offerToAccept = {
            ...offers[0],
            oldStatus: offers[0]?.status,
            status: "Accepted",
          };
          await handleSaveOfferAction({
            offer: offerToAccept,
            dealApplicationId: id,
            externalFunders,
            heldbacksData,
            saveHeldback,
            deleteHeldBack,
            saveFinalOffer,
            handleBankAmountUpdate,
            fetchRecalculatedApplication,
            updateSyndicatorsPercentage,
            refreshHeldabckComm,
            refreshSynd,
          });
        }
      }
    } catch (error: any) {
      console.error("Failed to automatically accept single offer", error);
    }
  };

  const populateSingleOfferPreApproved = async () => {
    try {
      const offers = await get(`getMultipleOffers/${id}`);

      if (
        Array.isArray(offers) &&
        offers.length === 1 &&
        !["ACCEPTED", "DECLINED"].includes(offers[0]?.status?.toUpperCase?.())
      ) {
        const offerToAccept = {
          ...offers[0],
          oldStatus: offers[0]?.status,
          status: "Accepted",
        };
        await handleSaveOfferAction({
          offer: offerToAccept,
          dealApplicationId: id,
          externalFunders,
          heldbacksData,
          saveHeldback,
          deleteHeldBack,
          saveFinalOffer,
          handleBankAmountUpdate,
          fetchRecalculatedApplication,
          updateSyndicatorsPercentage,
          refreshHeldabckComm,
          refreshSynd,
        });
      }
    } catch (error: any) {
      console.error("Failed to automatically accept single offer", error);
    }
  };

  const saveApplicationData = async () => {
    try {
      const updatedInfo = { ...merchantBusinessInfo };

      const formErrors = storeData
        ?.filter((item) => item.value && item.error)
        .map((item) => `${item.label} - ${item.helperText || "Invalid value"}`);

      if (formErrors.length > 0) {
        setValidationError(formErrors);
        return;
      }

      storeData.forEach((item) => {
        const keys = item.key.split(".");
        let temp = updatedInfo;

        for (let i = 0; i < keys.length - 1; i++) {
          if (!temp[keys[i]]) {
            temp[keys[i]] = {};
          }
          temp = temp[keys[i]];
        }
        temp[keys[keys.length - 1]] = item.value;
      });

      const response = saveMerchantData(updatedInfo);
      if (updatedInfo?.merchantId) {
        fetchMerchantData(updatedInfo?.merchantId);
      }
    } catch (error) {
      console.error("Failed to save application data:", error);
    }
  };

  const setStepInfo = () => {
    const currentActiveStep = steps[activeStep];
    let sendEmail = false;
    const events = currentActiveStep?.events;

    if (events && Array.isArray(events)) {
      for (const e of events) {
        if (e["email"]) {
          sendEmail = true;
          break;
        }
      }
    }
    setIsSendEmail(sendEmail);
  };

  const handleBackClick = async () => {
    await reInitializeDealApplicationStore();
    reInitializeSubmissionStore();
    await resetOffers();
    await resetHeldbacks();
    await resetSyndication();
    if (isFromDeals) {
      window.location.href = "#/deals";
    } else if (isFromOffers) {
      navigate("/offers");
    } else {
      navigate("/deal_applications");
    }
  };

  const roleName = localStorage.getItem(ROLE_NAME);

  const hideApproveButton = () => {
    try {
      const hideApproveButton = rolePermissionExists(
        window.rolePermission?.permissions,
        UPDATE,
        "MCA_DEAL_APPLICATIONS.HIDE_APPROVE_BUTTON"
      );
      return hideApproveButton;
    } catch (error: any) {
      return false;
    }
  };

  const renderTopButtons = (
    <Grid container height="50px" direction="row" alignItems={"center"}>
      <Box display="flex" alignItems="center">
        {/* Show full text button on large screens and up (≥1200px) */}
        <MDButton
          color="black"
          onClick={handleBackClick}
          sx={{ display: { xs: "none", xxl: "inline-flex" } }}
        >
          {isFromDeals ? "Back To Deals" : isFromOffers ? "Back To Offers" : "Back To Applications"}
        </MDButton>

        {/* Show icon button on medium screens and below (<1200px) */}
        <Tooltip
          title={
            isFromDeals ? "Back To Deals" : isFromOffers ? "Back To Offers" : "Back To Applications"
          }
        >
          <IconButton
            color="inherit"
            onClick={handleBackClick}
            sx={{ display: { xs: "inline-flex", xxl: "none" } }}
            aria-label="Back to Applications"
          >
            <ArrowBack />
          </IconButton>
        </Tooltip>
      </Box>
      <Box
        border={"1px solid #dcdcdc"}
        height={"40px"}
        borderRadius={"0.5rem"}
        padding={"5px"}
        marginLeft={"10px"}
        backgroundColor={"#f9f9f9"}
      >
        <MDTypography variant="h6" color="text" sx={{ fontWeight: "bold" }}>
          <span style={{ fontWeight: "normal" }}>ID</span> &nbsp;
          <span style={{ color: "#4f607c" }}>{dealApplicationData?.applicationNo}</span>
        </MDTypography>
      </Box>
      <Box
        border={"1px solid #dcdcdc"}
        height={"40px"}
        borderRadius={"0.5rem"}
        padding={"5px"}
        marginLeft={"10px"}
        backgroundColor={"#f9f9f9"}
        flexGrow={1}
      >
        <MDTypography variant="h6" color="text">
          <span style={{ fontWeight: "normal" }}>MERCHANT NAME</span> &nbsp;
          <span style={{ color: "#4f607c", fontWeight: "bold" }}>
            {merchantBusinessInfo?.merchantName}
          </span>
        </MDTypography>
      </Box>

      {/* Previous step */}
      {!(dealApplicationData?.subStatus === APPLICATION_STATUS.DRAFT) &&
      !(dealApplicationData?.subStatus === APPLICATION_STATUS.APPROVED) &&
      !(dealApplicationData?.status?.toLowerCase() === "approved") &&
      !isDeclined ? (
        <MDBox marginLeft={"10px"}>
          <MDButton
            color="black"
            block
            disabled={
              dealApplicationData?.subStatus === APPLICATION_STATUS.APPROVED ||
              !rolePermissionExists(
                window.rolePermission?.permissions,
                UPDATE,
                "MCA_DEALS.MCA_DEAL_APPLICATIONS"
              ) ||
              !dealApplicationData?.subStatus ||
              (roleName === SCRUBBER && parseInt(activeStep) > 1) ||
              (roleName === SUBMISSION && parseInt(activeStep) > 0)
            }
            onClick={(event) => {
              handleBack(event);
            }}
          >
            {isMobile ? "Previous" : "Previous Step"}
          </MDButton>
        </MDBox>
      ) : null}

      {/* Next step */}
      {dealApplicationData?.subStatus === APPLICATION_STATUS.DRAFT && !isDeclined ? (
        <MDBox marginLeft={"10px"}>
          <MDButton
            color="primary"
            disabled={
              dealApplicationData?.subStatus === APPLICATION_STATUS.APPROVED ||
              (roleName !== ADMIN && hideApproveButton())
            }
            onClick={async () => {
              await populateSingleOfferPreApproved();
              await updateDealApplication();
              await updateDealApplicationNo({ dealApplicationId: Number(id) });
              await updateDealApplication();
              fetchInitialData(id);
              handlePreApprovedClick();
            }}
          >
            {dealApplicationData?.subStatus === APPLICATION_STATUS.DRAFT ? "Approve" : "Completed"}
          </MDButton>
        </MDBox>
      ) : !(dealApplicationData?.subStatus === APPLICATION_STATUS.APPROVED) && !isDeclined ? (
        <MDBox marginLeft={"10px"}>
          <MDButton
            color="primary"
            disabled={
              dealApplicationData?.subStatus === APPLICATION_STATUS.APPROVED ||
              !rolePermissionExists(
                window.rolePermission?.permissions,
                UPDATE,
                "MCA_DEALS.MCA_DEAL_APPLICATIONS"
              ) ||
              !dealApplicationData?.subStatus ||
              (roleName === SCRUBBER && parseInt(activeStep) > 1) ||
              (roleName === SUBMISSION && parseInt(activeStep) > 0) ||
              (roleName !== ADMIN && isLastStep && hideApproveButton())
            }
            onClick={handleStatusUpdateClick}
            bsSize="sm"
            block
          >
            {isLastStep ? "Approve" : isMobile ? "Next" : "Next Step"}
          </MDButton>
        </MDBox>
      ) : null}

      {/* Save Button */}
      {!(dealApplicationData?.subStatus === APPLICATION_STATUS.APPROVED) && !isDeclined && (
        <MDBox marginLeft={"10px"}>
          <MDButton
            style={{ display: "flex", alignItems: "center", gap: 1 }}
            color="black"
            onClick={saveApplicationData}
          >
            <SaveOutlinedIcon />
            Save
          </MDButton>
        </MDBox>
      )}

      {/* Decline Button */}
      {!(dealApplicationData?.subStatus === APPLICATION_STATUS.APPROVED) && !isDeclined && (
        <MDBox marginLeft={"10px"}>
          <MDButton
            style={{ display: "flex", alignItems: "center", gap: 1 }}
            color="error"
            onClick={() => {
              setDeclineApp(true);
              setShowEmailModal(true);
            }}
          >
            <DeleteIcon />
            Decline
          </MDButton>
        </MDBox>
      )}

      {/* Undo Deal Button */}
      {dealApplicationData?.subStatus === APPLICATION_STATUS.APPROVED && !isDeclined && (
        <MDBox marginLeft={"10px"}>
          <MDButton
            style={{ display: "flex", alignItems: "center", gap: 1 }}
            color="warning"
            onClick={() => setShowUndoAlert(true)}
          >
            Undo Deal
          </MDButton>
        </MDBox>
      )}

      {/* Reset Button */}
      {isDeclined && (
        <MDBox marginLeft={"10px"}>
          <MDButton
            style={{ display: "flex", alignItems: "center", gap: 1 }}
            color="black"
            onClick={handleResetStatus}
          >
            <Refresh />
            Reset
          </MDButton>
        </MDBox>
      )}
    </Grid>
  );

  const undoDealConfirmation = (
    <Modal
      open={showUndoAlert}
      onClose={() => {
        setShowUndoAlert(false);
        setIsUndoConfirmed(false);
      }}
      aria-labelledby="undo-deal-modal"
      aria-describedby="undo-deal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "50%",
          maxWidth: 600,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        {isRefi ? (
          <Typography variant="body1" color="error" sx={{ fontWeight: "bold" }}>
            Please review the following information carefully before proceeding to undo the deal.
          </Typography>
        ) : (
          <MDBox>
            <Typography variant="h6" align="center" sx={{ fontWeight: "bold" }}>
              UNDO DEAL {dealApplicationData?.dealNo}
            </Typography>
            <Box
              sx={{ maxHeight: "calc(100vh - 210px)", overflowY: "auto", paddingBottom: 0, mt: 2 }}
            >
              <Paper sx={{ padding: 2 }}>
                <Typography variant="body1" color="error" sx={{ fontWeight: "bold" }}>
                  Please review the following information carefully before proceeding to undo the
                  deal.
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  {MESSAGES.UNDO_DEAL_MSG}
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  {isBuiltInMode ? MESSAGES.DELETE_CUSTOM_DEAL_MSG : MESSAGES.DELETE_DEAL_MSG}
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isUndoConfirmed}
                      onChange={(event) => {
                        setIsUndoConfirmed(event.target.checked);
                      }}
                    />
                  }
                  label="I understand the impact of undoing the deal and I have downloaded all necessary data from the deal for future reference."
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    mt: 2,
                  }}
                />
              </Paper>
            </Box>
          </MDBox>
        )}

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <MDButton
            variant="contained"
            color="error"
            onClick={() => {
              setShowUndoAlert(false);
              setIsUndoConfirmed(false);
            }}
          >
            Cancel
          </MDButton>

          {!isRefi && (
            <MDButton
              variant="contained"
              color="primary"
              onClick={async () => {
                try {
                  await handleUndoDeal();
                } finally {
                  setShowUndoAlert(false);
                  setIsUndoConfirmed(false);
                }
              }}
              disabled={!isUndoConfirmed}
            >
              Proceed
            </MDButton>
          )}
        </Box>
      </Box>
    </Modal>
  );

  const validationModal = validationError && validationError.length > 0 && (
    <WarningDialog
      open={!!validationError}
      confirmText="Ok"
      onConfirm={() => setValidationError(null)}
      message={
        <MDBox display="flex" flexDirection="column" gap={1}>
          {validationError?.map((error, key) => (
            <MDTypography key={key}>
              <span style={{ color: "red" }}>** </span>
              {error}
            </MDTypography>
          ))}
        </MDBox>
      }
      type="error"
      showActions={true}
    />
  );

  if (!hasDealApplicationAccess) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff0f0",
        }}
      >
        <Box
          sx={{
            padding: 4,
            borderRadius: 2,
            backgroundColor: "#ffe5e5",
            color: "#d32f2f",
            fontWeight: "bold",
            fontSize: "1.5rem",
            boxShadow: 3,
          }}
        >
          You do not have permission to view this Application
        </Box>
      </Box>
    );
  }

  return (
    <DashboardLayout>
      <Box sx={{ display: "flex", flexDirection: "column", height: "98vh" }}>
        <Box sx={{ flexShrink: 0 }}>
          {renderTopButtons}
          <Box>
            {dealApplicationData?.subStatus === APPLICATION_STATUS.DRAFT || preApprovedLocal ? (
              <Stepper
                activeStep={dealApplicationData?.subStatus === APPLICATION_STATUS.DRAFT ? 0 : 1}
                alternativeLabel
                className={"bg-primary"}
              >
                {preApprovedSteps.map((label, index) => (
                  <Step
                    key={index}
                    completed={
                      index <= (dealApplicationData?.subStatus === APPLICATION_STATUS.DRAFT ? 0 : 1)
                    }
                  >
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            ) : (
              <Stepper activeStep={Number(subStatus) + 1} alternativeLabel className={"bg-primary"}>
                {_steps.map((label, index) => (
                  <Step key={index} completed={index == subStatus + 1}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            )}

            <Box
              sx={{
                width: "100%",
                marginTop: "10px",
                borderRadius: "8px",
                backgroundColor: "#FFFFFF",
                padding: "4px 0",
                marginBottom: "12px",
                border: "1px solid #D7D7D8",
              }}
            >
              <Box sx={{ display: "flex", marginTop: "3px" }}>
                <Box sx={{ display: "inline-flex", width: "auto", marginLeft: "2px" }}>
                  <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="Detail Tabs"
                    sx={{
                      "& .MuiTab-root": {
                        marginRight: "20px",
                        padding: "1px 15px",
                        fontSize: "16px",
                        backgroundColor: "transparent",
                        "&:hover": {
                          backgroundColor: "transparent !important",
                        },
                      },
                      "& .MuiTabs-indicator": {
                        backgroundColor: "#F0F2F5",
                        height: "70% !important",
                        top: "15% !important",
                        borderRadius: "4px 4px 0 0",
                        transition: "none !important",
                      },
                    }}
                  >
                    {(permittedTabs["submission"] !== "none" || isPreApproved) && (
                      <Tab
                        value="submission"
                        label="Submission"
                        icon={<MailIcon />}
                        iconPosition="start"
                      />
                    )}

                    {(permittedTabs["fileUpload"] !== "none" ||
                      isPreApproved ||
                      (dealApplicationData?.applicationStatus &&
                        dealApplicationData?.applicationStatus.toLowerCase() === "closed")) && (
                      <Tab
                        value="files"
                        label="Files"
                        icon={<AssignmentIcon />}
                        iconPosition="start"
                      />
                    )}

                    {(permittedTabs["bankStatements"] !== "none" ||
                      isPreApproved ||
                      (dealApplicationData?.applicationStatus &&
                        dealApplicationData?.applicationStatus.toLowerCase() === "closed")) && (
                      <Tab
                        value="bank_statements"
                        label="Statements & Transactions"
                        icon={<AccountBalanceIcon />}
                        iconPosition="start"
                      />
                    )}


                    {(permittedTabs["offerDetails"] !== "none" ||
                      isPreApproved ||
                      (dealApplicationData?.applicationStatus &&
                        dealApplicationData?.applicationStatus.toLowerCase() === "closed")) && (
                      <Tab
                        value="analysisTools"
                        label="Analysis Tools"
                        icon={<PieChart/>}
                        iconPosition="start"
                       />
                    )}

                    {(permittedTabs["offerDetails"] !== "none" ||
                      isPreApproved ||
                      (dealApplicationData?.applicationStatus &&
                        dealApplicationData?.applicationStatus.toLowerCase() === "closed")) && (
                      <Tab
                        value="underwriting"
                        label="Offers"
                        icon={<ContactEmergencyIcon />}
                        iconPosition="start"
                      />
                    )}

                    {(permittedTabs["email"] !== "none" ||
                      (dealApplicationData?.applicationStatus &&
                        dealApplicationData?.applicationStatus?.toLowerCase() === "closed")) &&
                      StorageUtils.isFeatureEnabled("email") && (
                        <Tab
                          value="email"
                          label="Email"
                          icon={<DraftsTwoTone />}
                          iconPosition={"start"}
                        />
                      )}

                    {(permittedTabs["meeting"] !== "none" ||
                      (dealApplicationData?.applicationStatus &&
                        dealApplicationData?.applicationStatus.toLowerCase() === "closed")) &&
                      StorageUtils.isFeatureEnabled("meeting") && (
                        <Tab
                          value="meeting"
                          label="Meetings"
                          icon={<Groups />}
                          iconPosition={"start"}
                        />
                      )}

                    {(permittedTabs["clear"] !== "none" ||
                      permittedTabs["experian"] !== "none" ||
                      (dealApplicationData?.applicationStatus &&
                        dealApplicationData?.applicationStatus.toLowerCase() === "closed")) && (
                      <Tab
                        value="background_checks"
                        label="Background Checks"
                        icon={<ManageSearchIcon />}
                        iconPosition={"start"}
                      />
                    )}

                    {(permittedTabs["notes"] !== "none" || isPreApproved) && (
                      <Tab
                        value="notes"
                        label="Notes"
                        icon={<ModeCommentIcon />}
                        iconPosition="start"
                      />
                    )}
                  </Tabs>
                </Box>

                <Box marginLeft={"auto"} display="flex" alignItems="center" marginRight={1}>
                  {Object.entries(groupUsersByInitials(assignedUsers)).map(([initials, users]) => (
                    <Box key={initials} display="flex" alignItems="center">
                      {users.map((user, index) => (
                        <Tooltip key={index} title={user.role} arrow>
                          <div>
                            <UserAvatar
                              firstName={user.firstName}
                              lastName={user.lastName}
                              color={user.color}
                            />
                          </div>
                        </Tooltip>
                      ))}
                    </Box>
                  ))}
                  <Box sx={{ marginLeft: "15px" }}>
                    <UsersRole
                      appId={id}
                      assignedUsers={assignedUsers}
                      setAssignedUsers={setAssignedUsers}
                    >
                      <PersonAddAltSharpIcon />
                    </UsersRole>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={{ flex: 1, overflowY: "auto", height: "200px !important" }}>
          {activeTab === "submission" && (
            <Submission
              fetchUsersRole={fetchUsersRole}
              merchantData={merchantData}
              dealApplicationId={id}
              isReadOnly={permittedTabs["submission"] === "read"}
            />
          )}
          {activeTab === "files" && (
            <Files appId={id} isReadOnly={permittedTabs["fileUpload"] === "read"} />
          )}

          {activeTab === "bank_statements" && (
            <BankStatementTab
              focusedAccount={focusedAccount}
              isReadOnly={permittedTabs["bankStatements"] === "read"}
            />
          )}

          {activeTab === "analysisTools" && 
             (<AnalysisTools dealApplicationId={id} permittedTabs= {permittedTabs} onViewTransactions={handleViewBankStatement}/>)}

          {activeTab === "underwriting" && (
            <UnderWriting 
              dealApplicationId={id}
              onViewTransactions={handleViewBankStatement}
              isReadOnly={permittedTabs["offerDetails"] === "read"}
              permittedTabs={permittedTabs}
            />
          )}

          {activeTab === "email" && (
            <EmailTabComponent applicationId={id} isReadOnly={permittedTabs["email"] === "read"} />
          )}

          {activeTab === "meeting" && (
            <MeetingPage applicationId={id} isReadOnly={permittedTabs["meeting"] === "read"} />
          )}

          {activeTab === "background_checks" && (
            <BackgroundChecks
              appId={id}
              isReadOnly={permittedTabs["clear"] === "read" || permittedTabs["experian"] === "read"}
            />
          )}
          {activeTab === "notes" && (
            <NotesContent appId={id} isReadOnly={permittedTabs["notes"] === "read"} />
          )}
        </Box>
        {refresh && <FullPageLoader />}

        {showEmailModal && (
          <SendStatusEmailModal
            showModal={showEmailModal}
            onClose={() => {
              setDeclineApp(false);
              setShowEmailModal(false);
            }}
            dealApplicationId={id}
            isDecline={declineApp}
            isPreApproved={isPreApproved}
            dealApplication={dealApplicationData}
            handleSend={handleUpdateStatus}
            emailTemplateName={emailTemplateName}
            setEmailTemplateName={setEmailTemplateName}
          />
        )}

        {alert && (
          <MDSnackbar
            color={alert?.type === "success" ? "success" : "error"}
            icon="notifications"
            title={alert?.type === "success" ? "Success" : "Error"}
            content={alert?.message}
            dateTime=""
            autoHideDuration={3000}
            open={alert !== null}
            close={() => setAlert(null)}
          />
        )}

        {hasActiveSchedules && (
          <ConfirmDialog
            title={"Confirm"}
            body={en_message("CONFIRM_DEAL_REFINANCE_WHILE_ACTIVE_DEBIT", {
              dealNo: refinancedDealNumbers?.join(","),
            })}
            open={hasActiveSchedules}
            onClose={() => setHasActiveSchedules(false)}
            onConfirm={async () => {
              try {
                setRefresh(true);
                await updateEndDateForActiveSchedulesForRefinancedDeals({
                  dealApplicationId: Number(id),
                });
              } finally {
                setRefresh(false);
              }
              validateAllActions();
            }}
          />
        )}

        {showUndoAlert && undoDealConfirmation}
        {validationError && validationModal}
      </Box>
      {(isLoading || submissionLoader) && <FullPageLoader />}
    </DashboardLayout>
  );
};

export default withDommer(Detail);
